import { CheckCircle2, PhoneCall } from "lucide-react";
import { BRAND } from "../../lib/brand";
import { fmtMoney } from "../../lib/format";

export function QuoteSuccess({ result, onReset }) {
  const booking = result.request_type === "booking";
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-[#F1F5F9] px-4 py-16" data-testid="quote-success">
      <div className="max-w-lg text-center bg-white p-10 border border-slate-200 rounded-sm">
        <CheckCircle2 className="h-14 w-14 text-[#1E2A78] mx-auto mb-4" />
        <h2 className="text-2xl font-display font-bold text-[#0F172A]">{booking ? "Booking request received" : "Quote saved"}</h2>
        <div className="mt-4 text-xs uppercase tracking-wider text-slate-500">Your reference number</div>
        <div className="text-2xl font-mono font-bold text-[#1E2A78]" data-testid="quote-success-number">{result.quote_number}</div>
        <div className="mt-2 text-sm text-slate-600">Estimated total: <b>{fmtMoney(result.total, result.currency)}</b></div>
        {result.requires_confirmation ? (
          <div className="mt-5 flex gap-3 text-left p-4 bg-[#FFD700]/15 border border-[#FFD700] rounded-sm text-sm text-[#1E2A78]" data-testid="quote-success-confirm">
            <PhoneCall className="h-5 w-5 shrink-0 mt-0.5" />
            <span>Your booking is <b>pending confirmation</b>. Customer service will call you to confirm before it is finalized.</span>
          </div>
        ) : (
          <p className="mt-4 text-slate-600 text-sm">{booking ? "We'll contact you within 24 hours to schedule your pickup or drop-off." : "Keep your reference number. When you're ready to book, call us or submit a booking."}</p>
        )}
        <p className="mt-4 text-xs text-slate-500">Questions? Call <a href={BRAND.phoneHref} className="text-[#1E2A78] font-semibold">{BRAND.phone}</a></p>
        <button onClick={onReset} className="mt-6 px-5 py-2 bg-[#FFD700] text-[#1E2A78] font-semibold rounded-sm hover:bg-[#E6C200]" data-testid="quote-new-btn">Start a new quote</button>
      </div>
    </div>
  );
}
